import type React from 'react';
import { ConfirmationDialog } from 'shared-portal-components-v2';

import { useManageAccessModal } from '@/hooks/manageAccess/useManageAccessModal';
import ManageAccessStepper from '@/components/organism/ManageAccess/ManageAccessStepper';
import CreateSixWizardModal from '@/components/organism/CreateSix/CreateSixWizardModal';

function ManageAccessModal(): React.JSX.Element | null {
  const { state, handlers } = useManageAccessModal();

  if (!state.isOpen) return null;

  return (
    <>
      <CreateSixWizardModal
        isOpen={state.isOpen}
        onClose={handlers.handleClose}
        title={<span className="tracking-tight text-2xl font-bold">Manage SIX Participants</span>}
        isLoading={state.isSubmitting}
        steps={state.wizardSteps}
        isFirstStep={state.isFirstStep}
        isLastStep={state.isLastStep}
        isNextDisabled={state.isNextDisabled}
        nextDisabledTooltip={state.nextDisabledTooltip}
        onPrevious={handlers.handlePrevious}
        onNext={handlers.handleNext}
        onCancel={handlers.handleClose}
        nextButtonText="Next"
        finalButtonText="Confirm"
      >
        <ManageAccessStepper onClose={handlers.handleClose} />
      </CreateSixWizardModal>

      <ConfirmationDialog
        isOpen={state.isExternalConfirmationOpen}
        onClose={handlers.handleCloseExternalConfirmation}
        title="Proceed without adding the external user?"
        description="You have entered information to invite a new external user, but have not added them to the SIX. If you proceed without clicking 'Add to SIX', this new user information will not be saved and they will not receive a welcome email."
        onConfirm={handlers.handleConfirmExternalConfirmation}
        confirmText="Proceed to Review"
        cancelText="Keep Editing"
      />
    </>
  );
}

export default ManageAccessModal;
